import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

export default function Back({ to = '', show = false, children = 'Back' }) {
  return (
    <Link
      to={to}
      className={cn(styles.container, { [styles.show]: show && !!to })}
    >
      <UiKit.Button variant="outline">
        <i className="fas fa-arrow-left" />
        <div>{children}</div>
      </UiKit.Button>
    </Link>
  );
}
